import { render, staticRenderFns } from "./ProductivityReportTableHeader.vue?vue&type=template&id=2f0d110c"
import script from "./ProductivityReportTableHeader.vue?vue&type=script&lang=js"
export * from "./ProductivityReportTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports